(function () {
  'use strict';

  if (window.__florssFreeShippingInlineOnlyLoaded) return;
  window.__florssFreeShippingInlineOnlyLoaded = true;

  var THRESHOLD_CENTS = 24900;
  var PROMO_KIT_HANDLE = 'kit-360-pro-florss-reconstrucao';
  var cachedCart = null;

  function formatBRL(cents) {
    return (cents / 100).toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function parseBRL(text) {
    if (!text) return 0;

    var cleaned = String(text)
      .replace(/[^\d,.-]/g, '')
      .replace(/\./g, '')
      .replace(',', '.');

    return Math.round((parseFloat(cleaned) || 0) * 100);
  }

  function getQty() {
    var input = document.querySelector('[data-florss-qty] input[name="quantity"]');
    var qty = input ? parseInt(input.value, 10) : 1;
    return qty && qty > 0 ? qty : 1;
  }

  function getPriceEl() {
    return document.querySelector('[data-florss-price]');
  }

  function getUnitPriceCents() {
    var priceEl = getPriceEl();
    if (!priceEl) return 0;

    var unitFromDataset = parseInt(priceEl.dataset.florssUnitCents || '0', 10);
    if (unitFromDataset > 0) return unitFromDataset;

    var displayed = parseBRL(priceEl.textContent);
    var qty = getQty();

    if (qty > 1 && displayed > 0) {
      return Math.round(displayed / qty);
    }

    return displayed;
  }

  function getProductSubtotalCents() {
    return getUnitPriceCents() * getQty();
  }

  function buildBar(id, modifier) {
    var el = document.createElement('div');
    el.className = 'florss-free-shipping ' + (modifier || '');
    el.setAttribute('data-florss-free-shipping', id);

    el.innerHTML =
      '<div class="florss-free-shipping__text" data-florss-free-shipping-text></div>' +
      '<div class="florss-free-shipping__track">' +
        '<span class="florss-free-shipping__bar" data-florss-free-shipping-bar></span>' +
      '</div>';

    return el;
  }

  function getProductHandleFromPath() {
    var match = window.location.pathname.toLowerCase().match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function getCurrentProductHandle() {
    var root = document.querySelector('[data-florss-hero][data-product-handle]');
    var handle = root ? root.getAttribute('data-product-handle') : '';
    return String(handle || getProductHandleFromPath()).toLowerCase();
  }

  function isPromoKitProductPage() {
    return getCurrentProductHandle() === PROMO_KIT_HANDLE;
  }

  function cartHasPromoKit(cart) {
    var items = cart && Array.isArray(cart.items) ? cart.items : [];
    return items.some(function (item) {
      return String(item.handle || '').toLowerCase() === PROMO_KIT_HANDLE;
    });
  }

  function getCartTotalCents(cart) {
    if (!cart) return 0;
    return Math.max(Number(cart.total_price || cart.items_subtotal_price || 0), 0);
  }

  function fetchCartState() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      cache: 'no-store'
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Unable to load cart');
        return res.json();
      })
      .then(function (cart) {
        cachedCart = cart;
        return cart;
      });
  }

  function updateBar(bar, subtotalCents, options) {
    if (!bar) return;

    options = options || {};

    var text = bar.querySelector('[data-florss-free-shipping-text]');
    var fill = bar.querySelector('[data-florss-free-shipping-bar]');

    if (options.promoKit) {
      bar.classList.add('is-complete');
      bar.classList.add('florss-free-shipping--promo-kit');
      bar.style.setProperty('--florss-progress', '100%');

      if (fill) {
        fill.style.width = '100%';
      }

      if (text) {
        text.innerHTML = '<strong>Kit 360 Pro com frete gratis enquanto a promocao estiver ativa.</strong>';
      }

      return;
    }

    bar.classList.remove('florss-free-shipping--promo-kit');
    subtotalCents = Math.max(Number(subtotalCents || 0), 0);

    if (options.cartHasPromoKit) {
      bar.classList.add('is-complete');
      bar.style.setProperty('--florss-progress', '100%');

      if (fill) {
        fill.style.width = '100%';
      }

      if (text) {
        text.innerHTML = '<strong>Voce ganhou o frete gratis.</strong> Kit 360 Pro no carrinho.';
      }

      return;
    }

    var percent = Math.min((subtotalCents / THRESHOLD_CENTS) * 100, 100);
    var remaining = Math.max(THRESHOLD_CENTS - subtotalCents, 0);

    bar.style.setProperty('--florss-progress', percent.toFixed(2) + '%');

    if (fill) {
      fill.style.width = percent.toFixed(2) + '%';
    }

    if (subtotalCents >= THRESHOLD_CENTS) {
      bar.classList.add('is-complete');

      if (text) {
        text.innerHTML = '<strong>Voce ganhou o frete gratis.</strong>';
      }

      if (fill) {
        fill.style.width = '100%';
      }

      bar.style.setProperty('--florss-progress', '100%');
      return;
    }

    bar.classList.remove('is-complete');

    if (subtotalCents > 0) {
      if (text) {
        text.innerHTML =
          'Seu carrinho esta em <strong>' +
          formatBRL(subtotalCents) +
          '</strong>. Faltam <strong>' +
          formatBRL(remaining) +
          '</strong> para voce ganhar frete gratis.';
      }
      return;
    }

    if (text) {
      text.innerHTML = '<strong>Frete gratis acima de R$ 249.</strong> A barra atualiza pelo valor do carrinho.';
    }

    if (fill) {
      fill.style.width = '0%';
    }

    bar.style.setProperty('--florss-progress', '0%');
  }

  function removeTopBars() {
    document.querySelectorAll('[data-florss-free-shipping="product-top"]').forEach(function (bar) {
      bar.remove();
    });
  }

  function findInlineTarget() {
    return (
      document.querySelector('.florss-buybox__form') ||
      document.querySelector('.florss-buybox__actions') ||
      document.querySelector('.florss-product-form') ||
      document.querySelector('form[action*="/cart/add"]') ||
      document.querySelector('.florss-buybox')
    );
  }

  function ensureInlineBar() {
    var existing = document.querySelector('[data-florss-free-shipping="product-inline"]');
    if (existing) return existing;

    var target = findInlineTarget();
    if (!target) return null;

    var bar = buildBar('product-inline', 'florss-free-shipping--inline florss-free-shipping--below-buy');

    target.insertAdjacentElement('afterend', bar);

    return bar;
  }

  function updateProductBar() {
    removeTopBars();
    
    if (isPromoKitProductPage()) {
      updateBar(ensureInlineBar(), 0, { promoKit: true });
      return;
    }
    
    fetch('/cart.js', {
      credentials: 'same-origin',
      cache: 'no-store'
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        var cartTotal = Number(cart && cart.total_price ? cart.total_price : 0);
        var productSubtotal = getProductSubtotalCents();
        var total = productSubtotal > 0 ? productSubtotal : cartTotal;

        updateBar(
          ensureInlineBar(),
          total
        );
      })
      .catch(function () {
        updateBar(
          ensureInlineBar(),
          getProductSubtotalCents()
        );
      });
  }

  function updateCartBar() {
    if (window.location.pathname.replace(/\/$/, '') !== '/cart') return;

    fetchCartState()
      .then(function (cart) {
        var target =
          document.querySelector('#main-cart-items') ||
          document.querySelector('cart-items') ||
          document.querySelector('form[action="/cart"]') ||
          document.querySelector('main');

        if (!target) return;

        var bars = Array.prototype.slice.call(
          document.querySelectorAll('[data-florss-free-shipping="cart"]')
        );
        var bar = bars[0] || buildBar('cart', 'florss-free-shipping--cart');

        bars.slice(1).forEach(function (duplicate) {
          duplicate.remove();
        });

        if (!bar.parentNode || bar.parentNode !== target) {
          target.insertAdjacentElement('afterbegin', bar);
        }

        bar.style.display = '';
        bar.classList.add('florss-free-shipping--cart-main');
        updateBar(bar, getCartTotalCents(cart), {
          cartHasPromoKit: cartHasPromoKit(cart)
        });
      })
      .catch(function () {});
  }

  function refreshAll() {
    updateProductBar();
    updateCartBar();
  }

  function scheduleRefresh() {
    window.clearTimeout(window.__florssFreeShippingInlineOnlyTimer);
    window.__florssFreeShippingInlineOnlyTimer = window.setTimeout(refreshAll, 80);
  }

  function bindEvents() {
    document.addEventListener('click', function (event) {
      if (
        event.target.closest('[data-florss-qty-inc]') ||
        event.target.closest('[data-florss-qty-dec]') ||
        event.target.closest('[data-florss-variant]') ||
        event.target.closest('[data-florss-add-to-cart-submit]') ||
        event.target.closest('form[action*="/cart/add"] button[type="submit"]')
      ) {
        setTimeout(scheduleRefresh, 30);
        setTimeout(scheduleRefresh, 160);
        setTimeout(scheduleRefresh, 360);
        setTimeout(scheduleRefresh, 900);
      }
    });

    document.addEventListener('submit', function (event) {
      if (event.target.matches('form[action*="/cart/add"]')) {
        setTimeout(scheduleRefresh, 300);
        setTimeout(scheduleRefresh, 900);
        setTimeout(scheduleRefresh, 1600);
      }
    });

    document.addEventListener('input', function (event) {
      if (event.target.matches('[data-florss-qty] input[name="quantity"]')) {
        scheduleRefresh();
      }
    });

    document.addEventListener('change', function (event) {
      if (event.target.matches('[data-florss-qty] input[name="quantity"]')) {
        scheduleRefresh();
      }
    });

    document.addEventListener('florss:cart-updated', function (event) {
      cachedCart = event.detail || cachedCart;
      scheduleRefresh();
    });

    if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function (event) {
        cachedCart = event && event.cartData ? event.cartData : cachedCart;
        scheduleRefresh();
      });
    }

    var priceEl = getPriceEl();

    if (priceEl) {
      var observer = new MutationObserver(scheduleRefresh);

      observer.observe(priceEl, {
        childList: true,
        characterData: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['data-florss-unit-cents']
      });
    }
  }

  function init() {
    removeTopBars();
    bindEvents();

    refreshAll();
    setTimeout(refreshAll, 300);
    setTimeout(refreshAll, 900);
    setTimeout(refreshAll, 1600);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('pageshow', refreshAll);
})();


/* Florss - remover barra duplicada do carrinho */
(function () {
  function hideDuplicateCartFreeShippingBar() {
    var bars = Array.prototype.slice.call(
      document.querySelectorAll('[data-florss-free-shipping="cart"]')
    );

    bars.forEach(function (bar, index) {
      if (index === 0) {
        bar.style.display = '';
        bar.classList.add('florss-free-shipping--cart-main');
        return;
      }

      bar.remove();
    });
  }

  document.addEventListener('DOMContentLoaded', hideDuplicateCartFreeShippingBar);
  document.addEventListener('florss:cart-updated', hideDuplicateCartFreeShippingBar);
  setTimeout(hideDuplicateCartFreeShippingBar, 500);
  setTimeout(hideDuplicateCartFreeShippingBar, 1500);
})();

/* Florss - manter so a primeira barra de frete do carrinho */
(function () {
  function keepOnlyFirstCartFreeShippingBar() {
    var bars = document.querySelectorAll('[data-florss-free-shipping="cart"]');

    bars.forEach(function (bar, index) {
      if (index === 0) {
        bar.style.display = '';
        bar.classList.add('florss-free-shipping--cart-main');
      } else {
        bar.style.display = 'none';
      }
    });
  }

  document.addEventListener('DOMContentLoaded', keepOnlyFirstCartFreeShippingBar);
  document.addEventListener('florss:cart-updated', keepOnlyFirstCartFreeShippingBar);
  setTimeout(keepOnlyFirstCartFreeShippingBar, 300);
  setTimeout(keepOnlyFirstCartFreeShippingBar, 1000);
  setTimeout(keepOnlyFirstCartFreeShippingBar, 2000);
})();
